import { Option } from 'components/elements/FloatingToolbar/types'

import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'

import styles from './gridItem.module.scss'

const FloatingToolbarGridOption = ({ icon, label, disabled, customIcon, onClick, href, target }: Option) => {
  const base = (
    <button className={styles.option} onClick={onClick} disabled={disabled}>
      {icon && <Icon name={icon} />}
      {customIcon}
      <span>{label}</span>
    </button>
  )

  if (href)
    return (
      <Link className={styles.link} href={href} target={target}>
        {base}
      </Link>
    )

  return base
}

export default FloatingToolbarGridOption
